export default __webpack_public_path__ + "locales/hy-AM/DeleteDialog.json?hash=73642738c4c6223e0afa7db9bb14f6d5";